import React from "react";
import { useNavigate } from "react-router-dom";
import { SwiperSlide } from "swiper/react";
import { usePopularCityQuery } from "../../../api/queries/cityQueries";
import { SwiperWithArrow } from "../../../components/swiper/SwiperWithArrow";
import { useTranslationEx } from "../../../hooks/useTranslationEx";

const MajorTourDestSwiper: React.FC = () => {
  const navigate = useNavigate();

  const { data: popularCitiesRes, isLoading } = usePopularCityQuery();
  const { t2 } = useTranslationEx();
  if (isLoading) return <></>;

  return (
    <div className="relative">
      <SwiperWithArrow
        // arrowClassName="mt-[-2.5rem] sm:mt-[-3.5rem]"
        // onSlideChange={handleSlideChange}
        spaceBetween={22}
      >
        {popularCitiesRes?.popularDestination?.map((city) => (
          <SwiperSlide className="!w-[10.9375rem]" key={city.id}>
            <div
              role="button"
              onClick={() => navigate("/cities/" + city.slug)}
              className="flex flex-col items-center text-center"
            >
              <div className="relative mb-4 w-full overflow-hidden rounded-xl pt-[calc(236/175*_100%)]">
                <img
                  src={city.thumbnail}
                  alt={city.name}
                  className="absolute inset-0 h-full w-full object-cover"
                />
                <div className="absolute inset-0 flex h-full w-full flex-col items-start justify-end bg-[linear-gradient(180deg,_rgba(0,_0,_0,_0)_42.05%,_rgba(0,_0,_0,_0.6)_100%)] pb-3 pl-3">
                  <h5 className="text-sm font-normal leading-[22px] text-[#FFFFFF]">
                    {t2(city.countryName)}
                  </h5>
                  <p className="text-start text-lg font-semibold leading-[26px] text-[#FFFFFF]">
                    {t2(city.name)}
                  </p>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </SwiperWithArrow>
    </div>
  );
};

export default MajorTourDestSwiper;
